import React from 'react'

import { CPDSelectedItem } from 'front-end/src/pages/activity-history/activityHistoryTypes'
import { MenuItem, Box, MenuBulkAction } from 'front-end/src/components'
import { Trans } from '@lingui/macro'
import IconBookOpen from 'front-end/src/components/common/icon/IconBookOpen'
import IconBookCrossed from 'front-end/src/components/common/icon/IconBookCrossed'
import { useLooopTheme } from 'front-end/src/public-api/hooks/useLooopTheme'
import { MarkItemsAsCpdMutationFn } from 'front-end/src/pages/activity-history/ActivityHistory.codegen'
import { CpdBatchItemInput } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { useCPDFeatureFlag } from 'front-end/src/app/hooks/useFeatureFlags'

interface ActivityHistoryTableBulkActionProps {
  selectedItems: CPDSelectedItem[]
  isLoading: boolean
  markItemsAsCpd: MarkItemsAsCpdMutationFn
}

const ActivityHistoryTableBulkAction = ({
  selectedItems,
  isLoading,
  markItemsAsCpd
}: ActivityHistoryTableBulkActionProps) => {
  const { theme } = useLooopTheme()
  const { cpdAlias } = useCPDFeatureFlag()
  const isDisabled = !selectedItems.length || isLoading

  const handleMarkItemsAsCpd = (isCpd: boolean) => async () => {
    if (isLoading) return

    const cpdInput: CpdBatchItemInput[] = selectedItems.map((item) => ({
      ...item,
      isCpd
    }))

    await markItemsAsCpd({
      variables: {
        cpdInput
      }
    })
  }

  return (
    <Box mr="12px">
      <MenuBulkAction isDisabled={isDisabled}>
        <MenuItem
          icon={<IconBookOpen fontSize="18px" />}
          color={theme.colors.violet[600]}
          whiteSpace="nowrap"
          onClick={handleMarkItemsAsCpd(true)}
          maxW="none"
        >
          <Trans>Mark as {cpdAlias}</Trans>
        </MenuItem>
        <MenuItem
          icon={<IconBookCrossed />}
          whiteSpace="nowrap"
          onClick={handleMarkItemsAsCpd(false)}
          maxW="none"
        >
          <Trans>Unmark as {cpdAlias}</Trans>
        </MenuItem>
      </MenuBulkAction>
    </Box>
  )
}

export default ActivityHistoryTableBulkAction
